import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Routing } from '@medicalapp/shared-core';
import { AuthService } from '@core/services/auth/auth.service';

import { CurrentUserService } from '@core/services/common/current-user.service';

export const unauthGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  await currentUserService.getAsync();

  const isUnAuthenticated = authService.isUnAuthenticated();

  if (!isUnAuthenticated) {
    router.navigate([Routing.Secure]);
    return false;
  }
  
  return true;
};
